// ============================================
// negotiateRealtimeSdp — Azure OpenAI Realtime WebRTC handshake
// ============================================
// Wave 5e1 — extracted from initializeWebRTC().
//
// Pure I/O: builds an SDP offer, POSTs it to Azure OpenAI's Realtime
// /openai/v1/realtime/calls endpoint with the ephemeral key, and applies
// the returned SDP answer to the peer connection.
//
// The endpoint already includes the correct path (no api-version /
// deployment query params needed for the GA Protocol).

export const negotiateRealtimeSdp = async (
  peerConnection: RTCPeerConnection,
  endpoint: string,
  ephemeralKey: string,
): Promise<void> => {
  const offer = await peerConnection.createOffer()
  await peerConnection.setLocalDescription(offer)

  console.log('📡 WebRTC connecting to:', endpoint)
  const sdpResponse = await fetch(endpoint, {
    method: 'POST',
    body: offer.sdp,
    headers: {
      Authorization: `Bearer ${ephemeralKey}`,
      'Content-Type': 'application/sdp',
    },
  })

  if (!sdpResponse.ok) {
    throw new Error(`WebRTC connection failed: ${sdpResponse.status}`)
  }

  const answer = {
    type: 'answer' as RTCSdpType,
    sdp: await sdpResponse.text(),
  }
  await peerConnection.setRemoteDescription(answer)

  console.log('✅ WebRTC connected!')
}
